import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "text-h5 font-weight-bold" }
const _hoisted_3 = { class: "text-body-1 text-medium-emphasis mt-1" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "ml-auto text-h5 font-weight-bold" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "ml-auto text-h5 font-weight-bold" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_11 = { class: "d-flex justify-center mt-4 position-relative" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-h5 font-weight-bold" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_16 = { class: "text-body-1 font-weight-medium" }
const _hoisted_17 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_18 = { class: "text-body-1 font-weight-medium" }
const _hoisted_19 = { class: "d-flex justify-space-between align-center" }
const _hoisted_20 = { class: "text-body-1 font-weight-medium" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"250px"}
}
const _hoisted_22 = {
  key: 1,
  class: "d-flex justify-center align-center text-center pa-4",
  style: {"height":"250px"}
}
const _hoisted_23 = { class: "text-body-2 text-error" }
const _hoisted_24 = {
  key: 3,
  class: "text-center pa-8"
}
const _hoisted_25 = {
  key: 2,
  class: "text-center pa-8"
}
const _hoisted_26 = {
  key: 3,
  class: "text-center pa-8"
}
const _hoisted_27 = {
  key: 0,
  class: "d-flex justify-center align-center pa-8"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  class: "deviceSamples-container",
  style: {"max-height":"400px","overflow-y":"auto"}
}
const _hoisted_30 = { class: "text-body-2" }
const _hoisted_31 = { class: "text-caption text-grey" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "text-caption text-grey mt-1" }
const _hoisted_34 = {
  key: 1,
  class: "text-caption text-grey"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "text-caption text-grey"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "text-caption text-grey"
}
const _hoisted_39 = {
  key: 0,
  class: "text-center pa-8"
}
const _hoisted_40 = { class: "position-relative" }
const _hoisted_41 = { class: "carousel-indicators" }
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = { class: "text-body-1 font-weight-medium" }
const _hoisted_44 = { class: "d-flex flex-column" }
const _hoisted_45 = { class: "text-body-1 font-weight-medium" }
const _hoisted_46 = { class: "text-body-2 font-weight-medium" }
const _hoisted_47 = { class: "text-body-2" }
const _hoisted_48 = { class: "d-flex justify-space-between align-center" }
const _hoisted_49 = { class: "mt-2 d-flex justify-space-between align-center" }
const _hoisted_50 = { class: "text-body-2" }
const _hoisted_51 = { class: "d-flex align-center" }
const _hoisted_52 = { class: "d-flex align-center" }
const _hoisted_53 = {
  key: 0,
  class: "position-relative mb-4"
}
const _hoisted_54 = { class: "text-body-2" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "text-h5 font-weight-bold text-primary" }
const _hoisted_57 = { class: "text-h5 font-weight-bold text-success" }
const _hoisted_58 = { class: "text-h6 font-weight-bold" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
// import HumidityChart from '@/components/charts/HumidityChart.vue' // HIDDEN: Para uso futuro
import OxygenChart from '@/components/charts/OxygenChart.vue'
import TemperatureGaugeChart from '@/components/charts/TemperatureGaugeChart.vue'
import GrowthChart from '@/components/charts/GrowthChart.vue'
// import HumidityOxygenLineChart from '@/components/charts/HumidityOxygenLineChart.vue' // HIDDEN: Para uso futuro
import BatteryChart from '@/components/charts/BatteryChart.vue'
import TemperatureChart from '@/components/charts/TemperatureChart.vue'
import TemperatureOxygenChart from '@/components/charts/TemperatureOxygenChart.vue'
import RootTimelapse from '@/components/RootTimelapse.vue'
import { useDeviceSensorManager, type DeviceSensorData } from '@/composables/useDeviceSensorManager'
import { useMeasurementsStore } from '@/views/DeviceSamples/store'
import { DeviceSample } from '@/views/DeviceSamples/models/deviceSample'
import { useDeviceStore } from '@/views/Devices/store'
import { Device } from '@/views/Devices/models/device'
import { useRoute } from 'vue-router'
import { useDeviceLoader } from '@/composables/useDeviceLoader'

// Configuración y manejo de datos reales

export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceView',
  setup(__props) {

const route = useRoute()
const deviceId = route.params.id as string || 'default-device-id' // Obtener del route o usar valor por defecto

// Stores
const sensorManager = useDeviceSensorManager()
const measurementsStore = useMeasurementsStore()
const deviceStore = useDeviceStore()
const deviceLoader = useDeviceLoader()

// Estados reactivos para datos reales
const realSensorData = ref<DeviceSensorData>({
    temperatureData: [],
    oxygenData: [],
    batteryData: [],
    temperatureOxygenData: [],
    lastValues: {}
})

const realGrowthData = ref<Array<{ date: string, growth: number, newRoots: number }>>([])
const deviceMeasurements = ref<DeviceSample[]>([])
const showAllMeasurements = ref(false)
const currentDevice = ref<Device | null>(null)
const selectedSample = ref<DeviceSample | null>(null)
const showSampleDialog = ref(false)

// Ordenar mediciones por time desc (más reciente primero)
const sortedMeasurements = computed(() => {
    return [...deviceMeasurements.value].sort(
        (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime()
    )
})

const openSampleDialog = (sample: DeviceSample) => {
    selectedSample.value = sample
    showSampleDialog.value = true
}

// Loading states
const loadingRealData = ref(false)
const errorMessage = ref<string | null>(null)

// Función para calcular el nivel de batería desde voltaje
// Fórmula: Rango típico de batería 12V es 10.5V (0%) a 14.4V (100%)
const calculateBatteryLevel = (voltage: number): number => {
    const minVoltage = 10.5  // 0% batería
    const maxVoltage = 14.4  // 100% batería

    if (voltage <= minVoltage) return 0
    if (voltage >= maxVoltage) return 100

    const level = ((voltage - minVoltage) / (maxVoltage - minVoltage)) * 100
    return Math.round(level)
}

// Computed property para generar growth data desde deviceMeasurements reales
const computedGrowthDataFromMeasurements = computed(() => {
    return deviceMeasurements.value
        .filter(sample => sample.managed && sample.growthPercent !== null && sample.growthPercent !== undefined)
        .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
        .map(sample => ({
            date: new Date(sample.createdAt).toISOString().split('T')[0],
            growth: sample.growthPercent || 0,
            newRoots: sample.newRootsCount || 0
        }))
})

// Función para cargar todos los datos del dispositivo
const loadDeviceMeasurements = async () => {
    loadingRealData.value = true
    errorMessage.value = null

    try {
        // console.log('[DeviceView] ========== INICIO CARGA DE DATOS ==========')
        // console.log('[DeviceView] Loading data for device:', deviceId)

        // Primero, cargar los datos del dispositivo desde el store
        if (!deviceStore.devices || deviceStore.devices.length === 0) {
            // console.log('[DeviceView] Cargando lista de devices desde store...')
            await deviceLoader.loadDevicesByRole()
        }

        const foundDevice = deviceStore.devices.find(d => d.id === deviceId)
        if (foundDevice) {
            currentDevice.value = foundDevice
            // console.log('[DeviceView] Device encontrado:', foundDevice.name || foundDevice.id)
        } else {
            // console.log('[DeviceView] Device NO encontrado en store')
        }

        // Cargar datos de sensores, crecimiento y mediciones en paralelo
        // console.log('[DeviceView] Iniciando carga paralela de sensorData, growthData y deviceSamples...')
        const [sensorData, growthData, deviceSamples] = await Promise.all([
            sensorManager.loadDeviceSensorData(deviceId),
            sensorManager.loadGrowthData(deviceId),
            measurementsStore.getMeasurementsByDeviceId(deviceId)
        ])

        // console.log('[DeviceView] Resultado sensorData:', {
        //     temperatureCount: sensorData.temperatureData.length,
        //     oxygenCount: sensorData.oxygenData.length,
        //     batteryCount: sensorData.batteryData.length,
        //     temperatureOxygenCount: sensorData.temperatureOxygenData.length,
        //     lastValues: sensorData.lastValues
        // })

        realSensorData.value = sensorData
        realGrowthData.value = growthData
        deviceMeasurements.value = deviceSamples

        // console.log('[DeviceView] DeviceSamples loaded for device:', deviceId, {
        //     measurementsCount: deviceSamples.length,
        //     managedCount: deviceSamples.filter(m => m.managed).length,
        //     unManagedCount: deviceSamples.filter(m => !m.managed).length
        // })

        // Actualizar el objeto device con los últimos valores reales
        if (sensorData.lastValues.temperature !== undefined) {
            device.value.sensors.temperature = sensorData.lastValues.temperature
        }
        if (sensorData.lastValues.oxygen !== undefined) {
            device.value.sensors.oxygen = sensorData.lastValues.oxygen
        }
        if (sensorData.lastValues.batteryLevel !== undefined) {
            device.value.battery.level = sensorData.lastValues.batteryLevel
        }
        if (sensorData.lastValues.voltage !== undefined) {
            device.value.battery.voltage = sensorData.lastValues.voltage
        }

        // console.log('[DeviceView] Device data loaded successfully:', {
        //     temperaturePoints: sensorData.temperatureData.length,
        //     oxygenPoints: sensorData.oxygenData.length,
        //     batteryPoints: sensorData.batteryData.length,
        //     batteryDataSample: sensorData.batteryData.slice(0, 3),
        //     growthPoints: growthData.length,
        //     lastValues: sensorData.lastValues
        // })
        // console.log('[DeviceView] ========== FIN CARGA DE DATOS ==========')

    } catch (error) {
        errorMessage.value = error instanceof Error ? error.message : 'Error al cargar datos del dispositivo'
        console.error('[DeviceView] Error loading device data:', error)
    } finally {
        loadingRealData.value = false
    }
}

// Sensor readings data - UNUSED: Datos de ejemplo para referencia
/*
const sensorReadings = ref([
    {
        temperature: 22.5,
        oxygen: 18.3,
        humidity: 65,
        timestamp: '2024-02-15 15:00',
        batteryLevel: 78,
        growth: 3.2, // Algunos tienen crecimiento
        newRoots: 2
    },
    {
        temperature: 21.8,
        oxygen: 17.9,
        humidity: 68,
        timestamp: '2024-02-15 14:30',
        batteryLevel: 79,
        // Sin crecimiento en esta lectura
    },
    {
        temperature: 23.1,
        oxygen: 18.7,
        humidity: 62,
        timestamp: '2024-02-15 14:00',
        batteryLevel: 79,
        growth: 2.8,
        newRoots: 1
    },
    {
        temperature: 22.9,
        oxygen: 18.1,
        humidity: 64,
        timestamp: '2024-02-15 13:30',
        batteryLevel: 80,
        // Sin crecimiento
    },
    {
        temperature: 22.3,
        oxygen: 17.8,
        humidity: 66,
        timestamp: '2024-02-15 13:00',
        batteryLevel: 80,
        // Sin crecimiento
    },
    {
        temperature: 21.9,
        oxygen: 18.2,
        humidity: 67,
        timestamp: '2024-02-15 12:30',
        batteryLevel: 81,
        growth: 1.5,
        newRoots: 3
    },
    {
        temperature: 22.7,
        oxygen: 17.5,
        humidity: 63,
        timestamp: '2024-02-15 12:00',
        batteryLevel: 82,
    },
    {
        temperature: 21.5,
        oxygen: 18.9,
        humidity: 69,
        timestamp: '2024-02-15 11:30',
        batteryLevel: 82,
    },
    {
        temperature: 20.8,
        oxygen: 19.1,
        humidity: 71,
        timestamp: '2024-02-15 11:00',
        batteryLevel: 83,
        growth: 1.2,
        newRoots: 1
    },
    {
        temperature: 21.2,
        oxygen: 18.6,
        humidity: 68,
        timestamp: '2024-02-15 10:30',
        batteryLevel: 83,
    },
    {
        temperature: 22.1,
        oxygen: 17.7,
        humidity: 64,
        timestamp: '2024-02-15 10:00',
        batteryLevel: 84,
    },
    {
        temperature: 23.4,
        oxygen: 16.9,
        humidity: 59,
        timestamp: '2024-02-15 09:30',
        batteryLevel: 84,
    }
])
*/

// Growth data for chart - UNUSED: Datos de ejemplo para referencia
/*
const growthData = ref([
    { date: '2024-02-10', growth: 2.1, newRoots: 1 },
    { date: '2024-02-11', growth: 3.5, newRoots: 2 },
    { date: '2024-02-12', growth: 1.8, newRoots: 1 },
    { date: '2024-02-13', growth: 4.2, newRoots: 3 },
    { date: '2024-02-14', growth: 2.9, newRoots: 2 },
    { date: '2024-02-15', growth: 3.2, newRoots: 2 },
])
*/

// Datos para gráfico de batería - UNUSED: Datos de ejemplo para referencia
/*
const batteryData = ref([
    { timestamp: '2024-02-15T08:00:00Z', batteryLevel: 95, voltage: 12.4 },
    { timestamp: '2024-02-15T09:00:00Z', batteryLevel: 92, voltage: 12.3 },
    { timestamp: '2024-02-15T10:00:00Z', batteryLevel: 89, voltage: 12.2 },
    { timestamp: '2024-02-15T11:00:00Z', batteryLevel: 86, voltage: 12.1 },
    { timestamp: '2024-02-15T12:00:00Z', batteryLevel: 82, voltage: 12.0 },
    { timestamp: '2024-02-15T13:00:00Z', batteryLevel: 78, voltage: 11.9 },
])

// Datos para gráfico de temperatura simple
const temperatureData = ref([
    { timestamp: '2024-02-15T08:00:00Z', temperature: 22.5 },
    { timestamp: '2024-02-15T09:00:00Z', temperature: 23.1 },
    { timestamp: '2024-02-15T10:00:00Z', temperature: 24.0 },
    { timestamp: '2024-02-15T11:00:00Z', temperature: 25.2 },
    { timestamp: '2024-02-15T12:00:00Z', temperature: 26.8 },
    { timestamp: '2024-02-15T13:00:00Z', temperature: 23.4 },
])

// Datos para gráfico combinado temperatura-oxígeno
const temperatureOxygenData = ref([
    { timestamp: '2024-02-15T08:00:00Z', temperature: 22.5, oxygen: 21.2 },
    { timestamp: '2024-02-15T09:00:00Z', temperature: 23.1, oxygen: 20.8 },
    { timestamp: '2024-02-15T10:00:00Z', temperature: 24.0, oxygen: 20.5 },
    { timestamp: '2024-02-15T11:00:00Z', temperature: 25.2, oxygen: 20.1 },
    { timestamp: '2024-02-15T12:00:00Z', temperature: 26.8, oxygen: 19.7 },
    { timestamp: '2024-02-15T13:00:00Z', temperature: 23.4, oxygen: 20.9 },
])
*/

// Computed properties for chart data - UNUSED: Para ejemplo futuro
// const sortedTopics = computed(() => {
//     return [...topicData.value].sort((a, b) => b.percentage - a.percentage)
// })
// Últimas 3 imágenes reales de DeviceSamples (que tengan imageUrl)
const carouselImages = computed(() => {
    const samplesWithImage = deviceMeasurements.value
        .filter(sample => sample.imageUrl && sample.imageUrl.trim() !== '')
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .slice(0, 3)
        .map(sample => sample.imageUrl)
    return samplesWithImage.length > 0 ? samplesWithImage : ['/images/1.png']
})

const currentSlide = ref(0)
let carouselInterval: number | null = null

// Start the automatic carousel (solo si hay más de 1 imagen)
const startCarousel = () => {
    if (carouselImages.value.length <= 1) return
    carouselInterval = window.setInterval(() => {
        currentSlide.value = (currentSlide.value + 1) % carouselImages.value.length
    }, 3000)
}

// Clean up interval when component unmounts
onMounted(async () => {
    // Cargar datos reales del dispositivo (las imágenes vienen de aquí)
    await loadDeviceMeasurements()
    // Iniciar carrusel después de tener las imágenes reales
    currentSlide.value = 0
    startCarousel()
})

onBeforeUnmount(() => {
    if (carouselInterval) {
        clearInterval(carouselInterval)
    }
})

// Device data - Fotorizotron
const device = ref({
    id: 1,
    name: 'Fotorizotron - Hectarea 5',
    location: 'Atacama, Centro',
    icon: 'mdi-camera-outline',
    iconBg: '#E8F5E8',
    iconColor: '#4CAF50',
    battery: {
        level: 78,
        status: 'Good',
        estimatedDays: 12,
        voltage: 12.1
    },
    lastPhoto: {
        timestamp: '2024-02-15 14:30',
        path: '/images/roots/latest.jpg'
    },
    sensors: {
        temperature: 22.5,
        oxygen: 18.3,
        humidity: 65,
        lastUpdate: '2024-02-15 15:00'
    },
    rootAnalysis: {
        growthPercentage: 15.4,
        newRootsCount: 8,
        totalRootsDetected: 45,
        healthScore: 8.2,
        suggestedNextCapture: '2024-02-16 08:00'
    },
    status: {
        online: true,
        lastConnection: '2024-02-15 15:00',
        operatingDays: 45
    },
    tag: {
        text: 'Active',
        color: '#4CAF50'
    }
})

// Format budget display - UNUSED: Para ejemplo futuro
// const formatBudget = (total: number, used: number) => {
//     const formatValue = (value: number) => {
//         if (value >= 1000) {
//             return `$${(value / 1000).toFixed(1)}k`
//         }
//         return `$${value}`
//     }
//     return `${formatValue(used)} of ${formatValue(total)}`
// }

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "device-view-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "device-layout" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "scrollable-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "pa-6",
                        flat: "",
                        elevation: "3"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(currentDevice.value?.name || device.value.name), 1),
                            _createElementVNode("div", _hoisted_3, " Estado: " + _toDisplayString(currentDevice.value?.active ? 'Activo' : 'Inactivo') + " • Última actualización: " + _toDisplayString(currentDevice.value?.updatedAt ? new
                                        Date(currentDevice.value.updatedAt).toLocaleDateString('es-ES') : 'N/A'), 1),
                            _createVNode(_component_v_row, { class: "mt-6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      rounded: "lg",
                                      flat: "",
                                      class: "pa-4",
                                      color: "#F5F3FF"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                          _createVNode(_component_v_icon, {
                                            color: "#8465FF",
                                            size: "30",
                                            class: "pa-2 rounded bg-purple-lighten-5"
                                          }, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                              _createTextVNode("mdi-trending-up")
                                            ])),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_5, _toDisplayString(computedGrowthDataFromMeasurements.value.length > 0 ?
                                                        computedGrowthDataFromMeasurements.value[computedGrowthDataFromMeasurements.value.length
                                                            - 1].growth : 0) + "% ", 1)
                                        ]),
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-subtitle-1 mt-2" }, "Crecimiento", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      rounded: "lg",
                                      flat: "",
                                      class: "pa-4",
                                      color: "#EAF6FF"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_component_v_icon, {
                                            color: "#4CB3FF",
                                            size: "30",
                                            class: "pa-2 rounded bg-blue-lighten-5"
                                          }, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                              _createTextVNode("mdi-sprout")
                                            ])),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_7, _toDisplayString(computedGrowthDataFromMeasurements.value.length > 0 ?
                                                        computedGrowthDataFromMeasurements.value[computedGrowthDataFromMeasurements.value.length
                                                            - 1].newRoots : 0), 1)
                                        ]),
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-subtitle-1 mt-2" }, "Raíces Nuevas", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      rounded: "lg",
                                      flat: "",
                                      class: "pa-4",
                                      color: "#FFF8EA"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                          _createVNode(_component_v_icon, {
                                            color: "#FFA726",
                                            size: "30",
                                            class: "pa-2 rounded bg-amber-lighten-5"
                                          }, {
                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                              _createTextVNode("mdi-heart-pulse")
                                            ])),
                                            _: 1
                                          }),
                                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ml-auto text-h5 font-weight-bold" }, null, -1))
                                        ]),
                                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-subtitle-1 mt-2" }, "Salud Raíz", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "pa-6",
                        flat: "",
                        elevation: "3"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-h6 font-weight-bold" }, "Estado del Dispositivo", -1)),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(device.value.battery.status) + " • " + _toDisplayString(device.value.battery.estimatedDays) + " días restantes", 1),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_v_progress_circular, {
                                size: "160",
                                width: "12",
                                color: device.value.battery.level > 30 ? '#4CAF50' : '#FF5722',
                                "model-value": device.value.battery.level
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(device.value.battery.level) + "%", 1),
                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Batería", -1))
                                  ])
                                ]),
                                _: 1
                              }, 8, ["color", "model-value"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-body-2" }, "Temperatura:", -1)),
                                _createElementVNode("span", _hoisted_16, _toDisplayString(device.value.sensors.temperature) + "°C", 1)
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-body-2" }, "Oxígeno:", -1)),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(device.value.sensors.oxygen) + "%", 1)
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-body-2" }, "Voltaje:", -1)),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(device.value.battery.voltage) + "V", 1)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "mt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        flat: "",
                        elevation: "3",
                        class: "pa-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createTextVNode(" Temperatura ")
                            ])),
                            _: 1
                          }),
                          (loadingRealData.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  color: "primary"
                                })
                              ]))
                            : (errorMessage.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_v_icon, {
                                      color: "error",
                                      size: "48",
                                      class: "mb-2"
                                    }, {
                                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                                        _createTextVNode("mdi-alert-circle")
                                      ])),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(errorMessage.value), 1),
                                    _createVNode(_component_v_btn, {
                                      size: "small",
                                      color: "primary",
                                      class: "mt-2",
                                      onClick: loadDeviceMeasurements
                                    }, {
                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                        _createTextVNode(" Reintentar ")
                                      ])),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : (_openBlock(), _createBlock(TemperatureChart, {
                                  key: 2,
                                  "temperature-data": realSensorData.value.temperatureData,
                                  title: "Historial de Temperatura",
                                  height: "250px"
                                }, null, 8, ["temperature-data"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                flat: "",
                                elevation: "3",
                                class: "pa-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                      _createTextVNode(" Oxígeno Actual ")
                                    ])),
                                    _: 1
                                  }),
                                  (loadingRealData.value)
                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                        key: 0,
                                        indeterminate: "",
                                        color: "primary",
                                        class: "ma-4"
                                      }))
                                    : (errorMessage.value)
                                      ? (_openBlock(), _createBlock(_component_v_alert, {
                                          key: 1,
                                          type: "error",
                                          dense: "",
                                          class: "ma-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Error cargando datos de oxígeno: " + _toDisplayString(errorMessage.value), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (realSensorData.value.oxygenData && realSensorData.value.oxygenData.length > 0)
                                        ? (_openBlock(), _createBlock(OxygenChart, {
                                            key: 2,
                                            oxygen: realSensorData.value.oxygenData[realSensorData.value.oxygenData.length - 1]?.oxygen || 0
                                          }, null, 8, ["oxygen"]))
                                        : (_openBlock(), _createBlock(OxygenChart, {
                                            key: 3,
                                            oxygen: device.value.sensors.oxygen
                                          }, null, 8, ["oxygen"]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                flat: "",
                                elevation: "3",
                                class: "pa-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                      _createTextVNode(" Temperatura Actual ")
                                    ])),
                                    _: 1
                                  }),
                                  (loadingRealData.value)
                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                        key: 0,
                                        indeterminate: "",
                                        color: "primary",
                                        class: "ma-4"
                                      }))
                                    : (errorMessage.value)
                                      ? (_openBlock(), _createBlock(_component_v_alert, {
                                          key: 1,
                                          type: "error",
                                          dense: "",
                                          class: "ma-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Error cargando datos de temperatura: " + _toDisplayString(errorMessage.value), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                  _createVNode(TemperatureGaugeChart, {
                                    temperature: device.value.sensors.temperature
                                  }, null, 8, ["temperature"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        flat: "",
                        elevation: "3",
                        class: "pa-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode(" Estado de Batería ")
                            ])),
                            _: 1
                          }),
                          (loadingRealData.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                color: "primary",
                                class: "ma-4"
                              }))
                            : (errorMessage.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  type: "error",
                                  dense: "",
                                  class: "ma-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Error cargando datos de batería: " + _toDisplayString(errorMessage.value), 1)
                                  ]),
                                  _: 1
                                }))
                              : (realSensorData.value.batteryData && realSensorData.value.batteryData.length > 0)
                                ? (_openBlock(), _createBlock(BatteryChart, {
                                    key: 2,
                                    "battery-data": realSensorData.value.batteryData.map(d => ({
                                    timestamp: d.timestamp,
                                    batteryLevel: calculateBatteryLevel(d.voltage || 12),
                                    voltage: d.voltage || 0
                                })),
                                    title: "Voltaje de Batería",
                                    height: "250px",
                                    "show-voltage": true
                                  }, null, 8, ["battery-data"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(_component_v_icon, {
                                      size: "48",
                                      color: "grey-lighten-2"
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode("mdi-battery-outline")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis mt-2" }, "Sin datos de batería disponibles ", -1))
                                  ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "mt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        flat: "",
                        elevation: "3",
                        class: "pa-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode(" Historial de Crecimiento ")
                            ])),
                            _: 1
                          }),
                          (loadingRealData.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                color: "primary",
                                class: "ma-4"
                              }))
                            : (errorMessage.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  type: "error",
                                  dense: "",
                                  class: "ma-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Error cargando datos de crecimiento: " + _toDisplayString(errorMessage.value), 1)
                                  ]),
                                  _: 1
                                }))
                              : (computedGrowthDataFromMeasurements.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createVNode(_component_v_icon, {
                                      size: "48",
                                      color: "grey-lighten-2"
                                    }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode("mdi-chart-line")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis mt-2" }, "Sin datos de crecimiento disponibles ", -1)),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-caption text-grey" }, "Las mediciones analizadas aparecerán aquí", -1))
                                  ]))
                                : (_openBlock(), _createBlock(GrowthChart, {
                                    key: 3,
                                    "growth-data": computedGrowthDataFromMeasurements.value
                                  }, null, 8, ["growth-data"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        flat: "",
                        elevation: "3",
                        class: "pa-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode("mdi-timelapse")
                                ])),
                                _: 1
                              }),
                              _cache[28] || (_cache[28] = _createTextVNode(" Timelapse de Crecimiento "))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_subtitle, { class: "pa-0 mb-4 text-body-2 text-medium-emphasis" }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode(" Secuencia cronológica de fotos de raíces ")
                            ])),
                            _: 1
                          }),
                          (loadingRealData.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                color: "primary",
                                class: "ma-4"
                              }))
                            : (_openBlock(), _createBlock(RootTimelapse, {
                                key: 1,
                                samples: deviceMeasurements.value
                              }, null, 8, ["samples"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        flat: "",
                        elevation: "3",
                        class: "pa-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pa-0 mb-2" }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode(" Tendencia Temperatura-Oxígeno ")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_card_subtitle, { class: "pa-0 mb-4 text-body-2 text-medium-emphasis" }, {
                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                              _createTextVNode(" Correlación de temperatura y oxígeno en el tiempo ")
                            ])),
                            _: 1
                          }),
                          (loadingRealData.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                color: "primary",
                                class: "ma-4"
                              }))
                            : (errorMessage.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  type: "error",
                                  dense: "",
                                  class: "ma-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Error cargando datos combinados: " + _toDisplayString(errorMessage.value), 1)
                                  ]),
                                  _: 1
                                }))
                              : (realSensorData.value.temperatureOxygenData && realSensorData.value.temperatureOxygenData.length > 0)
                                ? (_openBlock(), _createBlock(TemperatureOxygenChart, {
                                    key: 2,
                                    "sensor-data": realSensorData.value.temperatureOxygenData,
                                    title: "Temperatura vs Oxígeno",
                                    height: "300px"
                                  }, null, 8, ["sensor-data"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createVNode(_component_v_icon, {
                                      size: "48",
                                      color: "grey-lighten-2"
                                    }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode("mdi-chart-line-variant")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis mt-2" }, "Sin datos disponibles", -1))
                                  ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                flat: "",
                class: "mt-6",
                elevation: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-6" }, {
                    default: _withCtx(() => [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "Mediciones del Dispositivo", -1)),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "text",
                        onClick: loadDeviceMeasurements
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[34] || (_cache[34] = [
                              _createTextVNode("mdi-refresh")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      (loadingRealData.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              color: "primary",
                              size: "40"
                            }),
                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "ml-3" }, "Cargando mediciones...", -1))
                          ]))
                        : (errorMessage.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 1,
                              type: "error",
                              class: "ma-4"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(errorMessage.value), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_v_row, { class: "mb-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                      _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "Fecha", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                      _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "Estado", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                      _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "Crecimiento", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                      _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "Salud", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                      _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "Nuevas Raíces", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "2" }, {
                                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                                      _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "Análisis", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((showAllMeasurements.value ? sortedMeasurements.value : sortedMeasurements.value.slice(0, 5)), (deviceSample) => {
                                  return (_openBlock(), _createBlock(_component_v_row, {
                                    key: deviceSample.id,
                                    class: _normalizeClass(["mb-2 deviceSample-row pa-2", { 'managed': deviceSample.managed, 'unmanaged': !deviceSample.managed }]),
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (openSampleDialog(deviceSample))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_30, [
                                            _createTextVNode(_toDisplayString(new Date(deviceSample.time).toLocaleDateString('es-ES')) + " ", 1),
                                            _createElementVNode("div", _hoisted_31, _toDisplayString(new Date(deviceSample.time).toLocaleTimeString('es-ES', {
                                                    hour: '2-digit', minute: '2-digit'
                                                })), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_chip, {
                                            size: "small",
                                            color: deviceSample.managed ? 'success' : 'warning',
                                            "text-color": deviceSample.managed ? 'white' : 'black'
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(deviceSample.managed ? 'Analizada' : 'Pendiente'), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["color", "text-color"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          (deviceSample.managed)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                _createVNode(_component_v_chip, {
                                                  size: "small",
                                                  color: deviceSample.growthPercent >= 3 ? 'success' : deviceSample.growthPercent >= 1 ? 'warning' : 'error'
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(deviceSample.growthPercent) + "% ", 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["color"]),
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(deviceSample.getGrowthCategory()), 1)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_34, " Sin análisis "))
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          (deviceSample.managed)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                _createVNode(_component_v_chip, {
                                                  size: "small",
                                                  color: deviceSample.rootHealthScore >= 8 ? 'success' : deviceSample.rootHealthScore >= 6 ? 'warning' : 'error'
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(deviceSample.rootHealthScore) + "/10 ", 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["color"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_36, " Sin análisis "))
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          (deviceSample.managed)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                _createVNode(_component_v_chip, {
                                                  size: "small",
                                                  color: "info"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(deviceSample.newRootsCount), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_38, " Sin análisis "))
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            color: "primary",
                                            variant: "text",
                                            onClick: _withModifiers(($event: any) => (openSampleDialog(deviceSample)), ["stop"])
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                size: "16",
                                                class: "mr-1"
                                              }, {
                                                default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                  _createTextVNode("mdi-eye")
                                                ])),
                                                _: 1
                                              }),
                                              _cache[44] || (_cache[44] = _createTextVNode(" Ver detalle "))
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "onClick"]))
                                }), 128)),
                                (sortedMeasurements.value.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createVNode(_component_v_icon, {
                                        size: "48",
                                        color: "grey"
                                      }, {
                                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                                          _createTextVNode("mdi-chart-line")
                                        ])),
                                        _: 1
                                      }),
                                      _cache[46] || (_cache[46] = _createElementVNode("div", { class: "text-h6 mt-2 text-grey" }, "No hay mediciones disponibles", -1)),
                                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "text-body-2 text-grey" }, "Las mediciones aparecerán aquí cuando se registren datos", -1))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (sortedMeasurements.value.length > 5)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    color: "primary",
                                    block: "",
                                    class: "mt-4",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllMeasurements.value = !showAllMeasurements.value))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(showAllMeasurements.value ? 'Ver menos' : `Ver todas (${sortedMeasurements.value.length})`), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "fixed-column mb-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "rounded-lg overflow-hidden",
                elevation: "3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_v_img, {
                      src: carouselImages.value[currentSlide.value],
                      height: "500",
                      cover: "",
                      class: "gradient-overlay fade-img"
                    }, {
                      placeholder: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "fill-height ma-0",
                          align: "center",
                          justify: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              color: "grey-lighten-5"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["src"]),
                    _createElementVNode("div", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselImages.value, (_, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["indicator-dot", { active: index === currentSlide.value }])
                        }, null, 2))
                      }), 128))
                    ]),
                    _createVNode(_component_v_avatar, {
                      size: "80",
                      class: "avatar-overlap"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          color: device.value.iconBg,
                          size: "72"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: device.value.iconColor,
                              size: "36"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(device.value.icon), 1)
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_card_item, { class: "pt-8 mt-6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold px-0" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentDevice.value?.name || device.value.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_subtitle, { class: "px-0" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(currentDevice.value?.description || device.value.location), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "px-4 pb-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_v_sheet, { class: "pa-3 rounded bg-grey-lighten-4 flex-grow-1 mr-2" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_43, _toDisplayString(computedGrowthDataFromMeasurements.value.length), 1),
                            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-caption text-grey" }, "Mediciones Analizadas", -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_sheet, { class: "pa-3 rounded bg-grey-lighten-4 flex-grow-1" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, " Creado: " + _toDisplayString(currentDevice.value ? new
                                            Date(currentDevice.value.createdAt).toLocaleDateString('es-ES') :
                                            'N/A'), 1),
                              _createElementVNode("div", _hoisted_46, " Periodicidad: " + _toDisplayString(currentDevice.value?.periodicity || 0) + " min ", 1)
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pt-3" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_47, _toDisplayString(currentDevice.value?.extendedName || 'Dispositivo') + " - " + _toDisplayString(currentDevice.value?.active ? 'Activo' : 'Inactivo') + ". Ubicación: " + _toDisplayString(currentDevice.value?.lat) + ", " + _toDisplayString(currentDevice.value?.lng), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", null, " Mediciones: " + _toDisplayString(deviceMeasurements.value.length), 1),
                        _createVNode(_component_v_chip, {
                          color: currentDevice.value?.active ? '#4CAF50' : '#FF9800',
                          "text-color": "white",
                          size: "small",
                          class: "rounded px-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentDevice.value?.active ? 'Activo' : 'Inactivo'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", null, "Score de salud: " + _toDisplayString(realSensorData.value.lastValues?.oxygen || 0) + "/30%", 1),
                        _createElementVNode("div", _hoisted_50, _toDisplayString(deviceMeasurements.value.filter(m => m.managed).length) + "/" + _toDisplayString(deviceMeasurements.value.length) + " Analizadas ", 1)
                      ]),
                      _createVNode(_component_v_progress_linear, {
                        "model-value": (deviceMeasurements.value.filter(m => m.managed).length / Math.max(deviceMeasurements.value.length, 1)) * 100,
                        height: "8",
                        rounded: "",
                        color: "primary",
                        class: "mt-1"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "d-flex justify-space-between pt-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_v_icon, {
                          color: currentDevice.value?.active ? 'green' : 'red',
                          size: "small",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentDevice.value?.active ? 'mdi-check-circle' : 'mdi-pause-circle'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"]),
                        _createElementVNode("span", null, _toDisplayString(currentDevice.value?.active ? 'Activo' : 'Inactivo'), 1)
                      ]),
                      _createVNode(_component_v_spacer),
                      _createElementVNode("div", _hoisted_52, [
                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "mr-2" }, "Batería", -1)),
                        _createVNode(_component_v_icon, {
                          size: "small",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => _cache[49] || (_cache[49] = [
                            _createTextVNode("mdi-battery")
                          ])),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(device.value.battery.level) + "%", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: showSampleDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showSampleDialog).value = $event)),
        "max-width": "700"
      }, {
        default: _withCtx(() => [
          (selectedSample.value)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5 px-6 py-4 bg-primary text-white" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-2" }, {
                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                          _createTextVNode("mdi-eye")
                        ])),
                        _: 1
                      }),
                      _cache[52] || (_cache[52] = _createTextVNode(" Detalle de Medición "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pa-6" }, {
                    default: _withCtx(() => [
                      (selectedSample.value.imageUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createVNode(_component_v_img, {
                              src: selectedSample.value.imageUrl,
                              "max-height": "350",
                              class: "rounded-lg",
                              cover: ""
                            }, {
                              placeholder: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "fill-height ma-0",
                                  align: "center",
                                  justify: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_progress_circular, {
                                      indeterminate: "",
                                      color: "primary"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["src"]),
                            _createVNode(_component_v_btn, {
                              icon: "",
                              size: "small",
                              color: "white",
                              class: "position-absolute",
                              style: {"top":"8px","right":"8px"},
                              href: selectedSample.value.imageUrl,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "18" }, {
                                  default: _withCtx(() => _cache[53] || (_cache[53] = [
                                    _createTextVNode("mdi-open-in-new")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_tooltip, {
                                  activator: "parent",
                                  location: "top"
                                }, {
                                  default: _withCtx(() => _cache[54] || (_cache[54] = [
                                    _createTextVNode("Abrir imagen en nueva pestaña")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["href"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_alert, {
                        type: "info",
                        variant: "tonal",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_54, [
                            _cache[55] || (_cache[55] = _createElementVNode("strong", null, "Fecha:", -1)),
                            _createTextVNode(" " + _toDisplayString(new Date(selectedSample.value.time).toLocaleString('es-ES')), 1),
                            _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
                            _cache[57] || (_cache[57] = _createElementVNode("strong", null, "Estado:", -1)),
                            _createTextVNode(" " + _toDisplayString(selectedSample.value.managed ? 'Analizada' : 'Pendiente'), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      (selectedSample.value.managed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createVNode(_component_v_row, { class: "mb-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  md: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      variant: "outlined",
                                      class: "pa-3 text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_56, _toDisplayString(selectedSample.value.growthPercent) + "%", 1),
                                        _cache[58] || (_cache[58] = _createElementVNode("div", { class: "text-caption" }, "Crecimiento", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  md: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      variant: "outlined",
                                      class: "pa-3 text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_57, _toDisplayString(selectedSample.value.newRootsCount), 1),
                                        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "text-caption" }, "Raíces Nuevas", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  md: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      variant: "outlined",
                                      class: "pa-3 text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "text-h5 font-weight-bold",
                                          style: _normalizeStyle({ color: selectedSample.value.getHealthScoreColor() })
                                        }, _toDisplayString(selectedSample.value.rootHealthScore) + "/10 ", 5),
                                        _cache[60] || (_cache[60] = _createElementVNode("div", { class: "text-caption" }, "Salud", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  md: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      variant: "outlined",
                                      class: "pa-3 text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_58, _toDisplayString(selectedSample.value.getGrowthCategory()), 1),
                                        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "text-caption" }, "Categoría", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, { class: "mb-4" }),
                            _createVNode(_component_v_list, { density: "compact" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[62] || (_cache[62] = [
                                        _createTextVNode("Color de Raíces")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedSample.value.rootColor || 'No especificado'), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[63] || (_cache[63] = [
                                        _createTextVNode("Patrón de Crecimiento")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedSample.value.growthPattern || 'No especificado'), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[64] || (_cache[64] = [
                                        _createTextVNode("Dirección Dominante")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedSample.value.dominantDirection || 'No especificado'), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[65] || (_cache[65] = [
                                        _createTextVNode("Calidad de Imagen")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedSample.value.imageQuality || 'No especificado'), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[66] || (_cache[66] = [
                                        _createTextVNode("Presencia de Hongos")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_chip, {
                                          size: "small",
                                          color: selectedSample.value.fungalPresence ? 'error' : 'success'
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(selectedSample.value.fungalPresence ? 'Sí' : 'No'), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["color"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (selectedSample.value.observation)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[67] || (_cache[67] = [
                                            _createTextVNode("Observaciones")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(selectedSample.value.observation), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createBlock(_component_v_alert, {
                            key: 2,
                            type: "warning",
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => _cache[68] || (_cache[68] = [
                              _createTextVNode(" Esta medición aún no ha sido analizada. ")
                            ])),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { class: "px-6 pb-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showSampleDialog.value = false))
                      }, {
                        default: _withCtx(() => _cache[69] || (_cache[69] = [
                          _createTextVNode("Cerrar")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})